module.exports = __webpack_public_path__ + "static/media/tejado.4c8257ec.png";